export default {
  explore: 'Explorar',
  stats: 'Métricas',
  myFolders: 'Carpetas',
  home: 'Qué es Kimple',
  howItWorks: 'Cómo funciona',
  content: 'Qué contenido',
  login: 'Ingresar',
  requestDemo: 'Quiero la demo',
  needHelp: ' ¿Necesitas ayuda?',
  logout: 'Cerrar sesión',
  programs: 'Programas Educativos',
  myProfile: 'Mi perfil',
  preferences: 'Preferencias',
  mySchool: 'Mi escuela',
  mySchoolGroup: 'Mi red de escuelas',
  seeInvitations: 'Ver invitaciones',
  impact: 'Impacto social',
  wantMyPlan: 'Quiero mi plan',
  remainingDays: '{days} días restantes',
  faqs: 'Preguntas frecuentes',
  changeLicense: 'Actualizar mi licencia',
  krea: 'Krea'
}

export const en = {
  explore: 'Explore',
  stats: 'Stats',
  myFolders: 'Folders',
  home: 'What is Kimple?',
  content: 'What content?',
  howItWorks: 'How it works',
  login: 'Sign In',
  requestDemo: 'Request a demo',
  needHelp: 'Need Help?',
  logout: 'Logout',
  programs: 'Educational Programs',
  myProfile: 'My profile',
  preferences: 'Preferences',
  mySchool: 'My school',
  mySchoolGroup: 'My school group',
  seeInvitations: 'See invitations',
  impact: 'Social impact',
  wantMyPlan: 'I want my plan',
  remainingDays: '{days} remaining days',
  faqs: 'FAQs',
  changeLicense: 'Update my license',
  krea: 'Krea'
}

export const ca = {
  explore: 'Explora',
  stats: 'Mètriques',
  myFolders: 'Carpetes',
  home: 'Què és Kimple',
  howItWorks: 'Com funciona',
  content: 'Quin contingut',
  login: 'Entra',
  requestDemo: 'Vull la prova',
  needHelp: 'Necessites ajuda?',
  logout: 'Tanca la sessió',
  programs: 'Programes Educatius',
  myProfile: 'El meu perfil',
  preferences: 'Preferències',
  mySchool: 'La meva escola',
  mySchoolGroup: 'La meva xarxa d\'escoles',
  seeInvitations: 'Ensenya\'m invitacions',
  impact: 'Impacte social',
  wantMyPlan: 'Vull el meu pla',
  remainingDays: 'Falten {days} dies',
  faqs: 'Preguntes freqüents',
  changeLicense: 'Actualitza la meva llicència',
  krea: 'Krea'
}
